const SET_LOADING = 'review/SET_LOADING';
const SET_REVIEW_LIST = 'review/SET_REVIEW_LIST';

const initialState = {
  size: 0,
  total: 0,
  reviewList: [],
  reviewListLoading: true,
};

// Action Creators

export function isLoading(payload) {
  return {
    type: SET_LOADING,
    payload: payload,
  };
}

export function setReviewList(payload, size, total) {
  return {
    type: SET_REVIEW_LIST,
    payload: payload,
    size: size,
    total: total,
  };
}

// Reducer

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

  case SET_LOADING:
    const key = `${action.attribute}Loading`;  // eslint-disable-line
    return {
      ...state,
      [key]: action.payload,
    };

  case SET_REVIEW_LIST:
    return {
      ...state,
      size: action.size,
      total: action.total,
      reviewList: action.payload,
      reviewListLoading: false,
    };

  default:
    return state;
  }
}
